import {
  Button, Card, CardActions, CardContent, Divider, Modal
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Camera, { FACING_MODES } from 'react-html5-camera-photo';
import { useTranslation } from 'react-i18next';
import ImagePreview from './ImagePreview';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));


function CamPopupModel({
  open, onClose, customer, ReceiptNo, DosyaTipi, DosyaTipiText, className, ...rest
}) {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const [dataUriUrl, setDataUri] = useState('');
  const [openCam, setOpenCam] = useState(false);
  function handleTakePhotoAnimationDone(dataUri) {
    setDataUri(dataUri);
    setOpenCam(true);
  }
  function onClosePreview(dataUri) {
    setOpenCam(false);
    onClose(dataUri);
  }

  const handleKapat = () => {
    setDataUri('');
    setOpenCam(false);
    onClose();
  };

  if (!open) {
    return null;
  }

  const isFullscreen = false;
  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <form>
          <CardContent>
            {
              (openCam)
                ? (
                  <ImagePreview
                    dataUri={dataUriUrl}
                    ReceiptNo={ReceiptNo}
                    DosyaTipi={DosyaTipi}
                    DosyaTipiText={DosyaTipiText}
                    onClose={onClosePreview}
                    isFullscreen={isFullscreen}
                  />
                )
                : (
                  <Camera
                    onTakePhotoAnimationDone={handleTakePhotoAnimationDone}
                    showFocus
                    isImageMirror={false}
                    isMaxResolution={true}
                    isFullscreen={true}
                    imageCompression={0.5}
                    idealFacingMode={FACING_MODES.ENVIRONMENT}
                  />
                )
            }
          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleKapat}
            >
              {t('Kapat')}
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

CamPopupModel.propTypes = {
  className: PropTypes.string,
  customer: PropTypes.any,
  DosyaTipi: PropTypes.string,
  DosyaTipiText: PropTypes.string,
  ReceiptNo: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

CamPopupModel.defaultProps = {
  open: false,
  onClose: () => { }
};

export default CamPopupModel;
